import { gql } from 'apollo-angular';
import committeeItems from '../../../committee-approval-dashboard/committee-items/graphql/committee-items';

export const PROJECT_DASHBOARD_FETCH_FRAGMENT = gql`
  ${committeeItems.COMMITTEE_ITEM_FIELDS}
  fragment ProjectDashBoardData on Project {
    id
    name
    is_repeat
    is_synced_link
    teams_url
    sharepoint_folder
    projectAttributes(
      hasAttribute: {
        column: NAME
        operator: IN
        value: ["Warehoused", "Not Warehoused"]
      }
    ) {
      id
      attribute {
        id
        name
      }
    }
    participants(
      hasRole: {
        column: NAME
        operator: IN
        value: [
          "Developer"
          "Account Manager"
          "Originator"
          "Sponsor"
          "Acquisition Analyst"
          "Closing Coordinator"
        ]
      }
    ) {
      organization {
        id
        name
        sponsor {
          id
          name
          is_repeat
        }
      }
      person {
        id
        name
      }
      role {
        name
      }
      sponsor {
        id
        name
        nickname
        is_repeat
      }
    }
    properties {
      total_units
      entity {
        id
        entityAddresses {
          address {
            zipCode {
              city
              state {
                abbreviation
              }
              county {
                id
                metroStatAreaCounties {
                  id
                  metroStatArea {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
    projectCredits {
      id
      crea_syndicated
      equity_amount
      amount
      certificated
      taxCreditType {
        name
        level
      }
      taxCreditDesignation {
        name
      }
      projectCreditOutlets {
        id
        ownership
        gross_equity
        estimated_gross_equity
        fund {
          id
          name
        }
        certificatedOutlet {
          id
          organization {
            id
            name
          }
        }
      }
    }
    isRepeatDeveloper
    pipelineProjects(
      hasPipeline: { column: NAME, operator: EQ, value: "Closing" }
    ) {
      closingDate: pipelineProjectDates(
        where: {
          AND: [
            { column: INITIAL_TARGET, value: false }
            {
              HAS: {
                relation: "pipelineMilestone"
                condition: {
                  AND: [
                    {
                      HAS: {
                        relation: "milestone"
                        condition: { column: "name", value: "Closed" }
                      }
                    }
                    {
                      HAS: {
                        relation: "pipeline"
                        condition: { column: "name", value: "Closing" }
                      }
                    }
                  ]
                }
              }
            }
          ]
        }
      ) {
        id
        date
      }
      pipelineProjectDates(where: { column: INITIAL_TARGET, value: false }) {
        id
        pipelineMilestone {
          milestone {
            id
            name
          }
        }
        date
      }
    }
    projectDisclosures {
      id
      disclosures
      milestone_id
    }
    projectStatuses(
      hasStatusSequence: { column: NAME, operator: EQ, value: "Closing" }
    ) {
      status {
        name
      }
    }
    projectSubstatusDates{
      id
      substatus {
        name
      }
      date
      utc_time
      timezone
    }
    committeeLinks {
      id
      name
      url
      is_default_link
      milestone_id
      is_package
    }
    committeeItems {
      ...CommitteeItemFields
    }
    committeeVotes(
      where: {
        HAS: {
          relation: "milestone"
          condition: { column: "name", operator: IN, value: $milestoneNames }
        }
      }
    ) {
      id
      status
      milestone_id
      milestone {
        id
        name
      }
      is_proxy
      project_id
      user {
        person {
          name
          first_name
        }
      }
      committeeVoteType {
        id
        name
        user {
          person {
            name
          }
        }
      }
      created
      modified
    }
    committeeApprovals(
      where: {
        HAS: {
          relation: "milestone"
          condition: { column: "name", operator: IN, value: $milestoneNames }
        }
      }
    ) {
      id
      status
      milestone_id
      project_id
      user {
        person {
          name
        }
      }
      committeeApprovalType {
        id
        name
        permissions {
          _create
          _edit
          _delete
        }
      }
      created
      modified
    }
  }
`;
export const DASHBOARD_MILESTONES_FRAGMENT = gql`
  fragment DashboardMilestoneData on Milestone {
    id
    name
    committeeApprovalTypes {
      id
      name
      permissions {
        _create
        _edit
        _delete
      }
    }
    committeeVoteTypes {
      id
      name
      user {
        person {
          name
        }
      }
      pivot {
        index
        committee_vote_type_id
        start_date
        end_date
      }
    }
  }
`;
export const get_committee_dashboard_project = gql`
  ${PROJECT_DASHBOARD_FETCH_FRAGMENT}
  ${DASHBOARD_MILESTONES_FRAGMENT}
  query getCommitteeDashboardProject($projectid: ID!, $milestoneNames: Mixed) {
    milestones(
      name: $milestoneNames
      orderBy: [
        { pipelineMilestones: { column: INDEX, aggregate: MAX }, order: DESC }
      ]
    ) {
      ...DashboardMilestoneData
    }
    committeeApprovalTypes {
      id
      name
      permissions {
        _create
        _edit
        _delete
      }
    }
    project(id: $projectid) {
      ...ProjectDashBoardData
    }
  }
`;

export const get_milestone_by_name = gql`
    query search_by_milestone($name: String!){
      search_by_milestone(name: $name){
        id
        name
      }
    }
`

